import { useEffect, useMemo, useState } from 'react';
import ChatContainerLegacy from './ChatContainerEntrevista';
import EntrevistaContinuaContainer from './EntrevistaContinuaContainer';
import { fetchScriptDocument } from '../services/interviewService';

const getRouteParams = () => {
  const pathname = window.location.pathname || '';
  const match = pathname.match(/^\/([^/]+)\/([^/]+)\/([^/]+)\/entrevista\/([^/]+)$/);
  return match
    ? { company: match[1], interviewType: match[2], denuncia: match[3], entrevistaId: match[4] }
    : {};
};

// Versão de script assumida pra resolução do modo — hoje só a v1.2 (materdei
// real e materdei-teste) carrega o campo `interviewMode`; se no futuro outra
// versão precisar disso, generalizar aqui (a resolução completa de versão
// que ChatContainerEntrevista.js faz — via getPesquisaScriptVersion — é mais
// pesada, e não vale a pena duplicar só pra decidir o modo).
const MODE_RESOLUTION_SCRIPT_VERSION = 'v1.2';

/**
 * Decide, SEM rota nova, entre o componente legado (roteiro fixo em vídeo +
 * Etapa 2 separada sob aprovação humana) e a entrevista contínua por IA nova
 * (interviewMode: 'ia_continua'), lendo o doc de script publicado — é a
 * única fonte de verdade disponível ANTES da entrevista começar (o doc de
 * entrevista em si só ganha `interviewMode` a partir do primeiro turno,
 * gravado por sendEntrevistaContinuaTurn). Fail-safe: qualquer erro ou
 * ambiguidade cai no componente legado, que é o comportamento de hoje pra
 * 100% dos clientes — essa troca nunca pode ser a causa de uma entrevista
 * real quebrar.
 */
export default function InterviewModeGate(props) {
  const { user, interviewType } = props;
  const routeParams = useMemo(() => getRouteParams(), []);
  const companyKey = routeParams.company || user?.company || 'materdei';
  const interviewTypeKey = interviewType || routeParams.interviewType || user?.entrevista || 'pesquisa-de-compliance';

  const [resolution, setResolution] = useState({ ready: false, mode: 'legado', scriptDoc: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const scriptDoc = await fetchScriptDocument({
          companyKey,
          interviewTypeKey,
          scriptVersion: MODE_RESOLUTION_SCRIPT_VERSION,
        });
        const mode = scriptDoc?.script?.interviewMode === 'ia_continua' ? 'ia_continua' : 'legado';
        if (!cancelled) setResolution({ ready: true, mode, scriptDoc });
      } catch (error) {
        console.warn('[EIA] Falha ao resolver interviewMode, seguindo com o fluxo legado:', error?.message || error);
        if (!cancelled) setResolution({ ready: true, mode: 'legado', scriptDoc: null });
      }
    })();
    return () => { cancelled = true; };
  }, [companyKey, interviewTypeKey]);

  // Enquanto resolve, não renderiza nada — App.js já cuida do resto do
  // layout (Home/FormContainer aparecem antes disso, via showChat), então
  // essa checagem é rápida (1 leitura de doc) e não introduz um novo estado
  // de loading visível de verdade na prática.
  if (!resolution.ready) return null;

  if (resolution.mode === 'ia_continua') {
    return <EntrevistaContinuaContainer {...props} scriptDoc={resolution.scriptDoc} />;
  }
  return <ChatContainerLegacy {...props} />;
}
